function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Instellingen",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Instellingen-/-Werkplektype-stiltewerkplek",
  transform: "translate(-1274.000000, -1164.000000)",
  stroke: "#425cd4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Actieve-tags",
  transform: "translate(119.000000, 1065.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Delete",
  transform: "translate(1156.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "bin-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14,3 L12.792,14.4726667 C12.7207131,15.1511037 12.1488385,15.6663086 11.4666667,15.6666667 L4.53333333,15.6666667 C3.85090648,15.6666667 3.27864694,15.1513572 3.20733333,14.4726667 L2,3",
  id: "Shape"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.333333333,
  y1: 3,
  x2: 15.6666667,
  y2: 3,
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5,3 L5,1 C5,0.631810167 5.29847683,0.333333333 5.66666667,0.333333333 L10.3333333,0.333333333 C10.7015232,0.333333333 11,0.631810167 11,1 L11,3",
  id: "Shape"
}), /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 6,
  x2: 8,
  y2: 13,
  id: "Shape"
}), /*#__PURE__*/React.createElement("line", {
  x1: 11,
  y1: 6,
  x2: 10.6666667,
  y2: 13,
  id: "Shape"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5,
  y1: 6,
  x2: 5.33333333,
  y2: 13,
  id: "Shape"
}))))));
function SvgTagDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagDelete);
export default __webpack_public_path__ + "static/media/Tag_Delete.8515d1b607d8c115e76355ebbd4d234b.svg";
export { ForwardRef as ReactComponent };